import { BoxProps, HStack, Text } from "@chakra-ui/react";
import { Icon } from "components";
import { ExchangeInfoDetail, ExchangeInfoDetailProps } from "./ExchangeInfo";

interface PositiveInfoProps extends BoxProps {}
export function PositiveInfo(props: PositiveInfoProps) {
  const { children, ...xprops } = props;

  return (
    <HStack {...xprops}>
      <Icon flexBasis="16px" type="infoFilled" boxSize="20px" minW="20px" minH="20px" />
      <Text fontSize="sm" fontWeight="500">
        {children}
      </Text>
    </HStack>
  );
}

export function PaymentExchangeInfoDetail(props: ExchangeInfoDetailProps) {
  return <ExchangeInfoDetail _description={{ fontWeight: "600" }} {...props} />;
}
